/* global SideDrawer */

if (!customElements.get('localization-drawer')) {
  class LocalizationDrawer extends SideDrawer {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.flagsLoaded = false;

      const drawerId = this.dataset.triggeredBy;
      this.localizationToggles = document.querySelectorAll(`[data-localization-trigger="${drawerId}"]`);
      this.overlay = document.querySelector('.js-localization-overlay');

      this.localizationForm = this.querySelector(`#form-${drawerId}`);
      this.localizationSubmit = this.querySelector('.js-localization-submit');

      // Custom country dropdown
      this.customCountry = this.querySelector('.js-localization-custom-country');
      this.countryValue = this.querySelector('.js-localization-country-value');
      this.countryLabel = this.querySelector('.js-localization-country-label');
      this.flagEl = this.querySelector('.js-localization-select-flag');

      // Custom language dropdown
      this.customLanguage = this.querySelector('.js-localization-custom-language');
      this.languageValue = this.querySelector('.js-localization-language-value');
      this.languageLabel = this.querySelector('.js-localization-language-label');

      this.localizationToggles.forEach((el) => {
        el.addEventListener('click', (evt) => this.toggleLocalization(evt.currentTarget));
      });

      this.localizationSubmit?.addEventListener('click', () => this.submitLocalization());

      this.initCustomDropdown(this.customCountry, this.selectCountry.bind(this));
      this.initCustomDropdown(this.customLanguage, this.selectLanguage.bind(this));
    }

    initCustomDropdown(el, onSelect) {
      if (!el) return;

      el.addEventListener('click', (e) => {
        const option = e.target.closest('.localization-custom-select__option');
        if (option) {
          onSelect(option);
          this.closeDropdown(el);
        } else {
          this.toggleDropdown(el);
          // Prevent the document handler below from immediately closing on this same event
          e.stopPropagation();
        }
      });

      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleDropdown(el);
        } else if (e.key === 'Escape') {
          this.closeDropdown(el);
        }
      });

      document.addEventListener('click', (e) => {
        if (!el.contains(e.target)) this.closeDropdown(el);
      });
    }

    toggleDropdown(el) {
      const isOpen = el.getAttribute('aria-expanded') === 'true';
      isOpen ? this.closeDropdown(el) : this.openDropdown(el);
    }

    openDropdown(el) {
      el.setAttribute('aria-expanded', 'true');
      this.loadFlagImages();
    }

    closeDropdown(el) {
      el?.setAttribute('aria-expanded', 'false');
    }

    selectCountry(option) {
      const value = option.dataset.value;
      const flagUrl = option.dataset.flagUrl;
      const labelText = option.querySelector('span:last-child').textContent;

      if (this.countryValue) this.countryValue.value = value;
      if (this.countryLabel) this.countryLabel.textContent = labelText;
      if (this.flagEl && flagUrl) {
        this.flagEl.style.setProperty('--flag-image', `url(${flagUrl})`);
      }

      this.customCountry.querySelectorAll('.localization-custom-select__option').forEach((opt) => {
        opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
      });
    }

    selectLanguage(option) {
      const value = option.dataset.value;
      const labelText = option.querySelector('span').textContent;

      if (this.languageValue) this.languageValue.value = value;
      if (this.languageLabel) this.languageLabel.textContent = labelText;

      this.customLanguage.querySelectorAll('.localization-custom-select__option').forEach((opt) => {
        opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
      });
    }

    toggleLocalization(opener) {
      if (this.localizationToggles.length === 0) return;

      const isActive = !this.localizationToggles[0].classList.contains('is-active');

      this.localizationToggles.forEach((el) => {
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-expanded', isActive);
      });

      this.filtersOpen = isActive;
      this.open(opener);
      this.loadFlagImages();
    }

    loadFlagImages() {
      if (this.flagsLoaded) return;

      // Load trigger flag
      if (this.flagEl) {
        const url = this.flagEl.getAttribute('data-flag-url');
        if (url) this.flagEl.style.setProperty('--flag-image', `url(${url})`);
      }

      // Load all option flags
      this.querySelectorAll('[data-flag-url]').forEach((el) => {
        const url = el.getAttribute('data-flag-url');
        if (url) el.style.setProperty('--flag-image', `url(${url})`);
      });

      this.flagsLoaded = true;
    }

    submitLocalization() {
      if (!this.localizationForm) return;
      this.localizationForm.submit();
    }
  }

  customElements.define('localization-drawer', LocalizationDrawer);
}
